import React, {useState} from 'react';
import { Menu, useGetList, useNotify } from 'react-admin';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CategoryIcon from '@mui/icons-material/Category';
import ImageIcon from '@mui/icons-material/Image';
import ReviewsIcon from '@mui/icons-material/Reviews';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailIcon from '@mui/icons-material/Email';
import SyncIcon from '@mui/icons-material/Sync';
import { getUser } from '../helper/user';
import { isGranted } from '../helper/security';
import { ROLES } from '../constants/Roles';
import { CompanySwitch } from './CompanySwitch';
import { ENTRYPOINT } from '../config/entrypoint';

export const AdminMenu = () => {
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const user = getUser();
  const isCourseCreator = user?.roles?.includes(ROLES.ROLE_COURSE_CREATOR);
  const { data: companies, isPending: companiesPending } = useGetList(
    'companies',
    { pagination: { page: 1, perPage: 1 } },
    { enabled: isCourseCreator }
  );
  const hasAssignedCompany = companies && companies.length > 0;

  if (user?.roles?.includes(ROLES.ROLE_SEO_EDITOR)) {
    return <Menu><Menu.Item to="/courses" primaryText="Courses" leftIcon={<SchoolIcon />} /></Menu>;
  }

  if (isCourseCreator) {
    return (
      <Menu>
        <CompanySwitch />
        {!companiesPending && hasAssignedCompany && (
          [
            <Menu.Item
              key="courses"
              to="/courses"
              primaryText="Courses"
              leftIcon={<SchoolIcon />}
            />,
            <Menu.Item
              key="add-course"
              to="/courses/create"
              primaryText="Add course"
              leftIcon={<SchoolIcon />}
            />,
          ]
        )}
      </Menu>
    );
  }

  const handleUpdateSequences = async () => {
    setLoading(true);
    fetch(`${ENTRYPOINT}/courses/sequences`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('auth')}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          notify(data.message, {type: "success"});
        } else {
          notify(`Error: ${data.message}`, {type: 'error'});
        }
      })
      .catch((error) => {
        notify(`Error: ${error.message}`, {type: 'error'});
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Menu>
      <CompanySwitch />
      <Menu.DashboardItem to={'/'} />
      {(isGranted(ROLES.ROLE_BRANCH_USER, user) ||
        isGranted(ROLES.ROLE_ADDER_AND_EDIT_OWN, user)) && (
        <Menu.Item
          to="/courses"
          primaryText="Courses"
          leftIcon={<SchoolIcon />}
        />
      )}

      {(isGranted(ROLES.ROLE_BRANCH_USER, user) ||
        isGranted(ROLES.ROLE_ADDER_AND_EDIT_OWN, user)) && (
        <Menu.Item
          to="/course_cities"
          primaryText="Course Cities"
          leftIcon={<LocationCityIcon />}
        />
      )}

      {(isGranted(ROLES.ROLE_REVIEW_CODE_USER, user) ||
        isGranted(ROLES.ROLE_ADDER_AND_EDIT_OWN, user)) && (
        <Menu.Item
          to="/course_city_dates"
          primaryText="Dates"
          leftIcon={<CalendarMonthIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_BRANCH_USER, user) && (
        <Menu.Item
          to="/inquiries"
          primaryText="Inquiries"
          leftIcon={<RequestPageIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_REVIEW_CODE_USER, user) && (
        <Menu.Item
          to="/reviews"
          primaryText="Reviews"
          leftIcon={<ReviewsIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_BRANCH_USER, user) && (
        <Menu.Item
          to="/media_objects"
          primaryText="Media"
          leftIcon={<ImageIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_BRANCH_USER, user) && (
        <Menu.Item
          to="/categories"
          primaryText="Categories"
          leftIcon={<CategoryIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_ADMIN, user) && (
        <Menu.Item
          to="/cities"
          primaryText="Cities"
          leftIcon={<LocationCityIcon />}
        />
      )}

      {isGranted(ROLES.ROLE_ADMIN, user) && (
        <Menu.Item
          to="/companies"
          primaryText="Companies"
          leftIcon={<BusinessIcon />}
        />
      )}
      {isGranted(ROLES.ROLE_ADMIN, user) && (
        <Menu.Item to="/users" primaryText="Users" leftIcon={<PeopleIcon />} />
      )}
      {isGranted(ROLES.ROLE_ADMIN, user) && (
        <Menu.Item
          to="/spammers"
          primaryText="Spammers"
          leftIcon={<EmailIcon />}
        />
      )}
        {isGranted(ROLES.ROLE_ADMIN, user) && (
            <Menu.Item
                to="#"
                onClick={handleUpdateSequences}
                primaryText="Update sequences"
                leftIcon={<SyncIcon />}
            />
        )}
    </Menu>
  );
};
